import { useMemo } from 'react';
import { useI18n } from '@tribeplatform/react-components/i18n';
import { SlateKit } from '../slate-kit.js';
export const useSlateKit = (options) => {
    const intl = useI18n();
    const slateKit = useMemo(() => new SlateKit(intl, options), [intl, options]);
    return slateKit;
};
//# sourceMappingURL=slate-kit.hook.js.map